var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymboraBranco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 69,
    viewBox: "0 0 187 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7788 41.304C50.7558 41.8497 52.4314 42.2299 53.7768 42.2299C56.0054 42.2299 57.1186 41.1041 57.1186 39.5501C57.1186 37.8636 56.0175 36.9979 53.9585 35.7204C50.6379 33.7391 49.3788 31.2648 49.3788 29.1209C49.3788 25.3282 51.9678 22.187 57.0594 22.187C58.6728 22.187 60.1754 22.6221 60.8795 23.0352L60.1241 26.9836C59.4335 26.5631 58.3954 26.1779 57.0345 26.1779C55.0068 26.1779 54.0369 27.3685 54.0369 28.617C54.0369 30.0332 54.7701 30.7803 57.3817 32.3086C60.6055 34.1899 61.7771 36.5811 61.7771 39.0576C61.7771 43.396 58.496 46.2204 53.7565 46.2204C51.794 46.2204 49.9081 45.7428 49.0957 45.2725L49.7788 41.3037V41.304Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4979 46.0107V36.9776L65.1533 22.3975H70.196L71.8519 28.0235C72.3096 29.5471 72.7619 31.3083 73.1265 33.0344H73.1985C73.4989 31.3358 73.894 29.6174 74.3384 27.9184L75.7667 22.3975H80.6676L75.2337 36.797V46.0111H70.4979V46.0107Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.269 37.754C100.145 35.4918 99.9933 32.4689 100.044 29.9221H99.9492C99.515 32.4539 98.8659 35.3599 98.4112 37.1962L96.2995 45.624H92.9464L90.9293 37.3295C90.4596 35.4193 89.8161 32.4839 89.4459 29.9221H89.3585C89.2884 32.4982 89.1157 35.4768 88.9921 37.8133L88.5804 46.0111H84.5273L86.2731 22.3975H91.261L93.2005 30.9424C93.8745 33.9371 94.4878 36.544 94.9225 39.2138H95.0024C95.3722 36.5916 95.9131 33.9316 96.5513 30.9424L98.4682 22.3975H103.458L104.935 46.0111H100.704L100.269 37.7544V37.754Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.331 42.5795C116.634 42.6495 116.977 42.6641 117.385 42.6641C119.311 42.6641 120.883 41.5108 120.883 39.1197C120.883 36.745 119.223 35.5185 117.352 35.5112H116.331V42.5799L116.331 42.5795ZM116.331 32.1023H117.346C119.061 32.1023 120.354 30.7077 120.354 28.789C120.354 27.0552 119.513 25.7155 117.584 25.7155C117.062 25.7155 116.634 25.758 116.331 25.8631V32.1023ZM111.623 22.7472C113.052 22.4396 114.951 22.292 117.002 22.292C119.251 22.292 121.478 22.5762 123.15 23.9591C124.449 25.0281 124.991 26.6081 124.991 28.2623C124.991 30.3576 123.874 32.3803 121.473 33.4145V33.5394C124.286 34.3231 125.776 36.578 125.776 39.1754C125.776 41.13 125.127 42.659 123.996 43.8148C122.548 45.349 120.079 46.199 116.012 46.199C114.217 46.199 112.705 46.0939 111.623 45.9335V22.7476L111.623 22.7472Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.009 34.2034C136.009 39.5596 137.032 42.2997 138.948 42.2997C140.951 42.2997 141.703 34.0104 141.703 34.0104C141.703 34.0104 141.049 26.1078 138.912 26.1078C137.031 26.1078 136.009 29.1365 136.009 34.2034ZM146.625 33.7888C146.625 42.6934 143.368 46.2906 138.761 46.2906C133.263 46.2906 131.087 40.6286 131.087 34.1481C131.087 27.6976 133.726 22.1162 139.108 22.1162C144.968 22.1162 146.625 28.3788 146.625 33.7888Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.573 33.0538H158.431C160.486 33.0538 161.654 31.4288 161.654 29.379C161.654 27.3585 160.832 25.936 158.72 25.8811C158.298 25.8811 157.835 25.9162 157.573 26.021V33.0534V33.0538ZM152.866 22.7472C154.351 22.4524 156.224 22.292 158.024 22.292C160.609 22.292 162.94 22.659 164.505 24.0488C165.978 25.3559 166.434 26.9329 166.434 28.9607C166.434 31.4878 165.159 33.7441 162.687 34.8578V34.9282C164.334 35.5775 165.174 37.06 165.637 39.6094C166.108 42.2232 166.76 45.1516 167.191 46.0108H162.256C161.952 45.3581 161.406 42.9721 161.035 40.3587C160.622 37.4226 159.85 36.5942 158.281 36.5942H157.573V46.0111H152.865V22.748L152.866 22.7472Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180.607 36.6589L179.796 31.7151C179.562 30.2802 179.237 27.9077 178.998 26.3472H178.911C178.65 27.915 178.29 30.3575 178.036 31.7224L177.147 36.6589H180.606H180.607ZM176.651 40.2209L175.586 45.6136H171L176.279 22H181.938L186.663 45.6136H182.062L181.025 40.2209H176.652H176.651Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6582 23.1245L40.7318 34.384L20.6582 45.6438V23.1245Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6211 0L40.6951 11.2599L20.6211 22.5197V0Z",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1087 46.1831L0.0351562 57.4426L20.1087 68.7028V46.1831Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0814 23.1157L0.0078125 34.3756L20.0814 45.6354V23.1157Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0736 22.5197L0 33.7796V9.90662L20.0736 0V22.5197Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6582 46.1837L40.7318 34.9238V58.7968L20.6582 68.7034V46.1837Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 16.6211,
    y: 0,
    width: 28.0742,
    height: 30.5197,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymboraBranco);
export default __webpack_public_path__ + "static/media/symboraBranco.e796a9adb646759078e7d4c057d4d840.svg";
export { ForwardRef as ReactComponent };